export default __webpack_public_path__ + "static/media/gnd_en_head_a1.68a45d61.mp3";